import { Image } from '@chakra-ui/react';
import ApplePosterPreview from '../../ApplePosterPreview';
import { POSTER_DEMO_DATA } from '../posterDemoData';
import { POSTER_DEMO_IMAGES, POSTER_DEMO_ICONS } from '../posterDemoAssets';
import { usePulseSequence } from '../usePulseSequence';
import { getPulseAnimation } from '../../../../utils/posterPulse';
import type { DemoScreen } from '../ApplePosterDemo';

const CARD_ICON_SIZE = '22px';

interface PassFrontScreenProps {
  onNavigate: (screen: DemoScreen) => void;
}

export const PassFrontScreen = ({ onNavigate }: PassFrontScreenProps) => {
  const { shouldPulse, recordClick } = usePulseSequence();
  const { venue, passFront } = POSTER_DEMO_DATA;

  const mapsUrl =
    `https://maps.apple.com/?ll=${venue.lat},${venue.lng}` +
    `&q=${encodeURIComponent(venue.name)}`;

  const navigate = (target: DemoScreen) => () => {
    recordClick();
    onNavigate(target);
  };

  return (
    <ApplePosterPreview
      images={{
        artwork: POSTER_DEMO_IMAGES.artwork,
        secondaryLogo: POSTER_DEMO_IMAGES.secondaryLogo,
      }}
      data={passFront.poster}
      cards={[
        {
          label: passFront.matchDetailsTitle,
          subtitle: passFront.matchDetailsSubtitle,
          onClick: navigate('matchInfo'),
          center: true,
          hideIcon: true,
          animation: getPulseAnimation(shouldPulse, 0),
        },
        {
          label: passFront.viewInMapsCard.title,
          subtitle: passFront.viewInMapsCard.action,
          href: mapsUrl,
          onClick: recordClick,
          center: true,
          icon: (
            <Image
              src={POSTER_DEMO_ICONS.map}
              alt=""
              boxSize={CARD_ICON_SIZE}
              objectFit="contain"
            />
          ),
          animation: getPulseAnimation(shouldPulse, 0),
        },
        {
          label: passFront.eventGuideCard.title,
          subtitle: passFront.eventGuideCard.action,
          onClick: navigate('eventGuide'),
          center: true,
          icon: (
            <Image
              src={POSTER_DEMO_ICONS.eventGuide}
              alt=""
              boxSize={CARD_ICON_SIZE}
              objectFit="contain"
            />
          ),
          animation: getPulseAnimation(shouldPulse, 0),
        },
      ]}
    />
  );
};
